import { Map, MapProps } from 'components/Organismos/Map'
import { Icon, LatLng } from 'leaflet'
import { useState } from 'react'
import { Marker, TileLayer, useMapEvents } from 'react-leaflet'

type ClickableMarkerProps = {
    initialMarker?: LatLng | null;
    customIcon?: Icon;
    onMarkerSet?: (newPosition: LatLng) => void;
}

type MarkableMapProps = ClickableMarkerProps & MapProps;


const ClickableMarker = ({
    initialMarker = null,
    customIcon,
    onMarkerSet
}: ClickableMarkerProps) => {
    const [position, setPosition] = useState<LatLng | null>(initialMarker);
    const map = useMapEvents({
        click(e) {
            map.panTo(e.latlng);
            setPosition(e.latlng);
            onMarkerSet?.(e.latlng);
        }
    })

    return position === null ? null : (
        <Marker icon={customIcon} position={position} />
    )
}

const MarkableMap = ({
    initialMarker,
    onMarkerSet,
    customIcon,
    ...rest
}: MarkableMapProps) => {
    return (
        <Map {...rest}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <ClickableMarker customIcon={customIcon} initialMarker={initialMarker} onMarkerSet={onMarkerSet} />
        </Map>
    );
}

export default MarkableMap